module.exports = __webpack_public_path__ + "static/media/click-black.4d67c383.svg";